import MicroModal from 'micromodal';

export default {

  init() {

  	if(!$('[data-micromodal-trigger]').length) {
  		return;
  	}

    $('template[data-js=modal]').each(function(index, elem) {
      var modal = elem.content.firstElementChild.cloneNode(true);
      document.body.appendChild(modal);
    });

    $('[data-micromodal-trigger]').on('click', function(e) {
      e.preventDefault();
    });

    MicroModal.init({
      onShow: this.show,
      onClose: this.close,
      disableFocus: false,
      disableScroll: true,
      debugMode: true
    });

  },

  show() {
    $('html').addClass('is-modal-open');
  },

  close() {
    $('html').removeClass('is-modal-open');;
  }

};
